/**
 * Language files are loaded on demand, depending on user preference. This includes translations, formatting data and fonts
 */
import loadFont from './load-font';



// Load font; note that failing to load the typekit font is handled by CSS fallbacks
const tryLoadFont = (language) => loadFont(language).catch(() => {
	console.debug('Failed to load font for language', language);
});

// Load all the files required by the application to be displayed in the chosen language
const loadLanguage = (language) => Promise.all([
	tryLoadFont(language)])
	.then(([translations]) => ({language, translations}));

// Attempt to load the preferred user language files, but fallback to the default language if that fails
const loadLanguageWithFallback = (preferredLanguage, defaultLanguage) => loadLanguage(preferredLanguage)
	.catch(() => {
		console.debug('Failed to load preferred language', preferredLanguage);

		// Try to load default language
		return loadLanguage(defaultLanguage);
	})
	.catch(() => {
		console.debug('Failed to load fallback language', defaultLanguage);
		throw new Error(`Failed to load languages ${preferredLanguage} and ${defaultLanguage}`);
	});


export default loadLanguageWithFallback;
